// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "footer-XRV54";
var _3 = "footer__price-5TefD";
var _4 = "price__from-3MYvQ";
var _5 = "footer__button-1zcBy";
var _6 = "footer_selected-fP6S8";
export { _1 as "__esModule", _2 as "footer", _3 as "footer__price", _4 as "price__from", _5 as "footer__button", _6 as "footer_selected" }
export default { "__esModule": _1, "footer": _2, "footer__price": _3, "price__from": _4, "footer__button": _5, "footer_selected": _6 }
